import { createStore, combineReducers, applyMiddleware } from 'redux';
import {Audio} from './audio';
import {HindiText} from './hindiText';
import {Auth} from './authUser';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

export const ConfigureStore = () =>{
    const store = createStore(
        combineReducers({
            audio: Audio,
            hindiText: HindiText,
            user: Auth
        }),
        applyMiddleware(thunk)
    );
    return store;
}